module.exports = "<div class=\"editorUi-row editorUi-dynamic-input\" v-show=\"!openCropper\">\n    <div class=\"editorUi-row\" v-if=\"options.length < 1 && type === 'categories'\">\n      Categories can be used for filtering item types in droplets like Grids or Feeds.\n    </div>\n     <v-select\n       v-model=\"display.selectedItems\"\n       multiple\n       @input=\"updateCategories\"\n       :options=\"options\">\n     </v-select>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/multi-select/template.html
// module id = Jw1V
// module chunks = 0